export const TOGGLE_HELP_DRAWER = 'TOGGLE_HELP_DRAWER';
export const TOGGLE_HELP_DRAWER_SUCCESS = 'TOGGLE_HELP_DRAWER_SUCCESS';

export const CHANGE_HELP_DRAWER_DATA = 'CHANGE_HELP_DRAWER_DATA';
export const CHANGE_HELP_DRAWER_DATA_SUCCESS = 'CHANGE_HELP_DRAWER_DATA_SUCCESS';
